import React from 'react';

export function AboutSection() {
  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="about-section" className="py-12 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Texte */}
          <div className="order-2 md:order-1">
            <h3 className="text-xs md:text-sm uppercase tracking-wider text-gray-500 mb-3 md:mb-4">
              About
            </h3>
            <h2 className="text-3xl md:text-5xl font-serif font-light mb-6 md:mb-8">
              PRV CREATIVE
            </h2>
            <div className="w-px h-16 md:h-24 bg-gray-300 mb-6 md:mb-8"></div>
            <p className="text-sm md:text-base leading-relaxed text-gray-700 mb-6 md:mb-8">
              Based in the heart of Paris, our agency is a collective of visionary creatives dedicated to capturing the essence of elegance through high-end photography. We believe that every project is a unique narrative, blending timeless sophistication with a modern editorial edge to tell your story beautifully. Our expert team works in total harmony to ensure that every detail reflects the prestige and excellence your brand deserves in this city. We invite you to discover our world where art meets professional precision.
            </p>
            <a
              href="#contact-section"
              onClick={handleContactClick}
              className="inline-block px-6 md:px-8 py-3 bg-gray-800 text-white text-xs md:text-sm uppercase tracking-wider hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us!
            </a>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 relative h-[400px] md:h-[600px]">
            <img
              src="https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/a0439da4e61f82f259e180502805699c.jpeg"
              alt="About PRV Creative"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
